module.exports = "<h2 class=\"page_title\">\r\n    <svg class=\"icon xl\">\r\n        <use xlink:href='#dashboard' />\r\n    </svg>\r\n    Dashboard\r\n</h2>\r\n<button type=\"button\" class=\"button btn-main\" data-toggle=\"modal\" data-target=\"#treePublishersFilter\">\r\n        Publishers\r\n        <svg class=\"icon sm caret\"><use xlink:href='#caret_1'/></svg>\r\n        </button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/header/header-menu.component.html
// module id = ./src/app/dashboard/header/header-menu.component.html
// module chunks = main